// src/BEDROCK/auth/ProtectedRoute.tsx
import { useAuthContext } from "./auth-provider";
import { Navigate } from "react-router-dom";
import { ReactNode } from "react";
import { usePaths } from "BEDROCK/paths";

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { session, isLoading } = useAuthContext();
  const { signIn } = usePaths();

  if (isLoading) return null; // or a loading spinner
  if (!session) return <Navigate to={signIn} replace />;

  return <>{children}</>;
};
